const plural = ({ count, keyword }) => {
	return `${keyword}${parseInt(count, 10) > 1 ? 's' : ''}`
}

export default plural
